import { Message, type Block } from 'slack-blocks-to-jsx';
import 'slack-blocks-to-jsx/dist/style.css';
import wundoAppIcon from './wundoAppIcon.png';

/*
 * Block Kit drawn by slack-blocks-to-jsx, as the message reads in Slack. Inert:
 * a button's url can be a sign-in link minted for the person the notification
 * went to, which is nobody else's to open.
 */

export interface SlackBlocksPreviewProps {
  blocks: Block[];
  theme?: 'light' | 'dark';
}

export function SlackBlocksPreview({ blocks, theme = 'light' }: SlackBlocksPreviewProps) {
  return (
    <div inert>
      <Message blocks={blocks} logo={wundoAppIcon} name='Wundo' theme={theme} />
    </div>
  );
}
